import styled, { css } from 'styled-components';

import { COLOR, mixins, textStyles } from '#@/shared/utils/styles';

const popupPadding = 15;

interface MessageProps {
  color: COLOR;
}

export const Message = styled.div<MessageProps>`
  display: flex;
  align-items: flex-start;
  position: relative;
  width: 300px;
  padding: ${popupPadding}px;
  border-radius: 8px;
  color: ${COLOR.white};
  background: ${(props) => props.color};

  ${mixins.boxShadowLight2022()};
`;

export const TextWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const Title = styled.div`
  ${textStyles.labelLarge500};
  ${mixins.truncateText(css`
    /* Don't force text into a single line. Note that this doesn't work on IE */
    white-space: normal;
  `)};
`;

export const Description = styled.div`
  margin-top: 8px;
  white-space: pre-wrap;
  ${textStyles.bodyMedium450};
`;

interface IconWrapperProps {
  $position: 'first' | 'last';
}

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  /* height must equal line-height of toast title */
  height: 20px;

  ${(props) =>
    props.$position === 'first'
      ? css`
          margin-right: 13px;
        `
      : css`
          margin: 0 5px;
        `};
`;
